import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import { computed, ref } from 'vue';
import { useConnectionStore } from '../connection';
import { API, Auth } from '@vp/common';

const AUTH_TOKEN_KEY = 'vpAuthToken';

export const useAuthStore = defineStore('auth', () => {
  const connectionStore = useConnectionStore();

  const config = ref<API.VPConfig.VPConfig | undefined>(undefined);

  const token = useStorage<string | undefined>(AUTH_TOKEN_KEY, undefined);
  const isLoggedIn = computed(() => !!token.value);
  const loginError = ref<string | null>(null);

  connectionStore.setAuthToken(token.value);

  const login = async (email: string, password: string) => {
    loginError.value = null;

    const cognito = config.value?.cognito;

    if (!cognito || !cognito.clientId || !cognito.region) {
      throw new Error('Cognito config is missing');
    }

    try {
      const { AccessToken, IdToken } = await Auth.getCognitoToken(email, password, {
        clientId: cognito.clientId,
        region: cognito.region,
      });

      const { authToken, returnTo } = await Auth.exchangeCognitoToken(connectionStore.apiClient!, AccessToken!, IdToken);

      token.value = authToken;
      connectionStore.setAuthToken(token.value);

      return { success: true, returnTo };
    } catch (e) {
      loginError.value = e.message;
      return { success: false };
    }
  };

  const logout = () => {
    token.value = undefined;
    connectionStore.setAuthToken(undefined);
  };

  return {
    config,

    token,
    isLoggedIn,
    login,
    logout,

    loginError,
  };
});
